import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ActionFormatter({ info }) {
  const { row } = getInfo(info)
  return <div>{ACTIONS_OPTIONS[row?.action]}</div>
}

export const actionFormatter = value => ACTIONS_OPTIONS[value]

const ACTIONS_OPTIONS = {
  denied: 'Denied',
  allowed: 'Allowed',
  created: 'Created',
  reset: 'Reset',
  revenue: 'Revenue',
  revenue_cor: 'Revenue Correction',
  manual: 'Manual',
  suppressed: 'Revenue Suppressed',
}
